'use client';

import { GeneralLiveNow } from '@fanduel/formation-react-icons';
import Link from 'next/link';
import { useAccountUm } from '@/hooks/use-account-um';

type LivestreamNavLinkProps = {
    pathname: string;
    name: string;
    isLoggedIn: boolean;
    onNavigationClick: (event: React.MouseEvent<HTMLAnchorElement>, shouldShowLoading?: boolean) => Promise<void>;
};

export const LivestreamNavLink = ({ pathname, name, isLoggedIn, onNavigationClick }: LivestreamNavLinkProps) => {
    const { triggerLogin } = useAccountUm();

    const handleClick = async (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (!isLoggedIn) {
            event.preventDefault();
            triggerLogin({ externalReferrer: pathname.replace(/^\/+/, '') });
            await onNavigationClick(event, false);
            return;
        }

        await onNavigationClick(event);
    };

    return (
        <Link href={pathname} prefetch={false} onClick={handleClick}>
            <GeneralLiveNow width={16} height={16} aria-hidden />
            <span className="image-text__span">{name}</span>
        </Link>
    );
};
